
import React from 'react';
import { BookOpen, Plus, Library } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyKnowledgeBaseStateProps {
  title?: string;
  description?: string;
  showButton?: boolean;
  buttonText?: string;
  onNewKnowledgeBase?: () => void;
  type?: 'knowledge-base' | 'document';
}

const EmptyKnowledgeBaseState = ({ 
  title, 
  description, 
  showButton = true,
  buttonText,
  onNewKnowledgeBase,
  type = 'knowledge-base'
}: EmptyKnowledgeBaseStateProps) => {
  // Default title and description based on type
  const defaultTitle = type === 'knowledge-base' 
    ? "No knowledge bases found" 
    : "No documents found";
  
  const defaultDescription = type === 'knowledge-base'
    ? "Create a new knowledge base to store your documents"
    : "Add documents to this knowledge base to get started";
  
  const defaultButtonText = type === 'knowledge-base'
    ? "New Knowledge Base"
    : "Add Document";
  
  // Use provided values or defaults
  const displayTitle = title || defaultTitle;
  const displayDescription = description || defaultDescription;
  const displayButtonText = buttonText || defaultButtonText;

  return (
    <div className="text-center py-12 border rounded-lg bg-muted/20 h-full flex flex-col items-center justify-center">
      <div className="flex flex-col items-center">
        <Library className="h-16 w-16 mb-2 text-muted-foreground" />
        <BookOpen className="h-12 w-12 text-muted-foreground/60 -mt-6 ml-8" />
      </div>
      <h3 className="mt-6 text-xl font-medium">{displayTitle}</h3>
      <p className="mt-2 text-muted-foreground max-w-md">
        {displayDescription}
      </p>
      {showButton && onNewKnowledgeBase && (
        <Button 
          onClick={onNewKnowledgeBase} 
          className="mt-6 gap-2"
          type="button"
        >
          <Plus size={16} />
          {displayButtonText}
        </Button>
      )}
    </div>
  );
};

export default EmptyKnowledgeBaseState;
